import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const SECTIONS = [
  { id: 'home', label: 'Inicio' },
  { id: 'about', label: 'Acerca de' },
  { id: 'services', label: 'Servicios' },
  { id: 'properties', label: 'Propiedades' },
  { id: 'contact', label: 'Contacto' },
];

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isHome = useLocation().pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // En la home se desplaza suave a la sección; en otras páginas el enlace /#sección
  // lleva a la home y el navegador baja hasta el ancla.
  const handleSectionClick = (e, sectionId) => {
    setIsMobileMenuOpen(false);
    if (!isHome) return;
    const element = document.getElementById(sectionId);
    if (element) {
      e.preventDefault();
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="nav-brand" onClick={() => setIsMobileMenuOpen(false)}>
          <img src="/LandingPageAssets/Logos/jk-logo-full-300.png" alt="J&K Realty" className="logo" width="300" height="68" />
        </Link>

        <div className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          {SECTIONS.map(({ id, label }) => (
            <a key={id} href={`/#${id}`} onClick={(e) => handleSectionClick(e, id)} className="nav-link">{label}</a>
          ))}
        </div>

        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Abrir menú"
          aria-expanded={isMobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
